var map = {
	"./dashboard/system/logo_grupo_merca_white.svg": "e6e2",
	"./dashboard/system/sidebar.png": "8e13",
	"./login/logo-dark.png": "c9c7",
	"./login/logo-yntech-white.png": "7430",
	"./login/logo.png": "ba69",
	"./login/logo_grupo_merca.png": "07f6",
	"./login/logotipo.svg": "091b",
	"./login/newbg.png": "90ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";